// @flow
import type { Filter } from 'app/common/react/components/profile/ProfileSearch/types';

export type SearchData = {
  filter: Filter,
  queryText: string,
  sortBy: string,
};

export const CloseSearchPanel = {
  type: 'CLOSE_STOREFRONT_SEARCH_PANEL',
};

export const CancelSearch = {
  type: 'CANCEL_STOREFRONT_SEARCH',
};

export const ClearSearchFilter = {
  type: 'CLEAR_SEARCH_FILTER',
};

export const DeleteDisplayFilter = {
  type: 'DELETE_DISPLAY_FILTER',
};

export function openSearchPanel(inputFocus: boolean) {
  return {
    type: 'OPEN_STOREFRONT_SEARCH_PANEL',
    payload: inputFocus,
  };
}

export function submitSearch(params: SearchData) {
  return {
    type: 'SUBMIT_STOREFRONT_SEARCH',
    payload: params,
  };
}

export function updateDisplayFilter(filter: Filter) {
  return {
    type: 'UPDATE_DISPLAY_FILTER',
    payload: filter,
  };
}
